function calculateSanitization(price) {
    let round = 1.0;

    if (price < 2) {
        round = 0.1;
    }

    else if (price < 10) {
        round = 0.25;
    }
    else if (price < 20) {
        round = 0.5;
    }
    return parseFloat((parseInt(price / round) * round).toFixed(2));
}
export default calculateSanitization;
